document.addEventListener('DOMContentLoaded', function () {
    const discountCode = document.querySelector(".js-discount-code");
    if (!discountCode) return;

    const group = discountCode.querySelector(".js-discount-code-group");
    if (!group) return;

    const input = discountCode.querySelector(".js-discount-code-input");
    const button = discountCode.querySelector(".js-discount-code-button");
    if (!input || !button) return;

    const displaysContainer = discountCode.querySelector(".js-discount-code-displays");
    if (!displaysContainer) return;

    const displayCode = displaysContainer.querySelector(".js-display-code");
    if (!displayCode) return;

    button.addEventListener("click", () => {
        const code = input.value.trim();
        if (!code) return;

        fetch(`${window.Shopify.routes.root}cart/update.js`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify({ discount: code })
        })
        .then(res => res.json())
        .then(data => {
            console.log("Discount code added:", code);
            console.log("Cart updated:", data);

            VueMinicart.config.globalProperties.$store.dispatch('initCart');

            input.value = "";
            displaysContainer.classList.remove("hidden");

            displayCode.innerHTML = "";
            if (Array.isArray(data.discount_codes) && data.discount_codes.length > 0) {
                data.discount_codes.forEach(({ code, applicable }) => {
                    if (applicable) {
                        const alreadyDisplayed = displayCode.querySelector(`[data-code-name="${code}"]`);
                        if (!alreadyDisplayed) {
                            displayCode.innerHTML += `
                                <span class="minicart__display-code-name">${code}</span>
                                <span class="minicart__display-code-remove js-display-code-remove" data-code-name="${code}">Remove</span>
                            `;
                        }
                    }
                });
            }
            group.classList.add('hidden');
        })
        .catch(err => {
            console.error("Error applying discount:", err);
        });
    });

    displayCode.addEventListener("click", (e) => {
        const remove = e.target.closest(".js-display-code-remove");
        if (!remove) return;

        const code = remove.dataset.codeName;
        if (!code) return;

        fetch(`${window.Shopify.routes.root}cart/update.js`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            body: JSON.stringify({ discount: "" })
        })
        .then(res => res.json())
        .then(data => {
            console.log("Discount code removed:", code);
            console.log("Cart updated:", data);

            VueMinicart.config.globalProperties.$store.dispatch("initCart");

            displaysContainer.classList.add("hidden");
            displayCode.innerHTML = "";

            group.classList.remove('hidden');
        })
        .catch(err => {
            console.error("Error removing discount code:", err);
        });
    });
});